// Vehicle Speed to RPM/RPS tool: field metadata + client-side per-field validation, used
// for instant inline feedback as the user types. The actual conversion math and the
// authoritative (server-side) validation live in the main backend — see
// src/lib/toolsApi.js (vehicleSpeedRpmToolApi) and backend/tools/vehicle_speed_rpm_tool.py.

export const DEFAULT_INPUTS = {
  speedUnit: 'kmph',
  speedValue: 60,
  wheelRadiusM: 0.30,
  gearRatio: 4.0,
  finalDriveRatio: 3.5,
};

export const SPEED_UNITS = [
  { value: 'kmph', label: 'km/h', max: 250 },
  { value: 'ms', label: 'm/s', max: 69.4 },
];

// speedValue's own bounds here are intentionally wide (0-500); the tighter, unit-specific
// range (see SPEED_UNITS above) is enforced as a cross-field check once the unit is known
// — mirrors FIELD_SPECS + SPEED_UNIT_BOUNDS in backend/core/lookup/vehicle_speed_rpm_specs.py.
export const FIELD_SPECS = [
  { key: 'speedValue', label: 'Vehicle Speed', unit: '', group: 'speed', min: 0, max: 500, strictlyPositive: false },
  { key: 'wheelRadiusM', label: 'Wheel Radius', unit: 'm', group: 'drivetrain', min: 0.20, max: 0.50, strictlyPositive: false },
  { key: 'gearRatio', label: 'Gear Ratio', unit: ':1', group: 'drivetrain', min: 1, max: 15, strictlyPositive: false },
  { key: 'finalDriveRatio', label: 'Final Drive Ratio', unit: ':1', group: 'drivetrain', min: 1, max: 6, strictlyPositive: false },
];

export function validateField(spec, rawValue) {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 'Required.';
  }
  const value = Number(rawValue);
  if (Number.isNaN(value)) {
    return 'Must be a number.';
  }
  if (spec.strictlyPositive && value <= 0) {
    return 'Must be greater than 0.';
  }
  if (spec.min !== null && value < spec.min) {
    return `Must be ≥ ${spec.min}.`;
  }
  if (spec.max !== null && value > spec.max) {
    return `Must be ≤ ${spec.max}.`;
  }
  return null;
}

// Unit-specific range check, mirrors SPEED_UNIT_BOUNDS cross-check in
// backend/tools/vehicle_speed_rpm_tool.py. Runs only once the generic FIELD_SPECS check
// above already passed for speedValue.
export function validateSpeedValueForUnit(speedValue, speedUnit) {
  const unit = SPEED_UNITS.find((u) => u.value === speedUnit) || SPEED_UNITS[0];
  const value = Number(speedValue);
  if (value > unit.max) {
    return `Must be ≤ ${unit.max} ${unit.label}.`;
  }
  return null;
}
